import { Component, Input, TemplateRef, ContentChild, AfterContentInit, ChangeDetectorRef } from '@angular/core';

export interface TableColumn {
  key: string;
  label: string;
  sortable?: boolean;
  align?: 'left' | 'center' | 'right';
  width?: string;
}

@Component({
  selector: 'app-data-table',
  templateUrl: './data-table.component.html',
  styleUrls: ['./data-table.component.scss']
})
export class DataTableComponent implements AfterContentInit {
  @Input() columns: TableColumn[] = [];
  @Input() data: any[] = [];
  @Input() isLoading = false;
  @Input() emptyMessage = 'No data found.';
  @ContentChild('rowTemplate', { static: false }) rowTemplate?: TemplateRef<any>;
  @ContentChild('loadingTemplate', { static: false }) loadingTemplate?: TemplateRef<any>;
  @ContentChild('emptyTemplate', { static: false }) emptyTemplate?: TemplateRef<any>;
  @Input() striped = true;
  @Input() hover = true;
  /** Key to track rows by (e.g. 'id') for better *ngFor performance; falls back to index */
  @Input() trackByKey?: string;

  constructor(private cdr: ChangeDetectorRef) {}

  trackByRow(index: number, row: any): number | string {
    if (this.trackByKey && row && row[this.trackByKey] != null) {
      return row[this.trackByKey];
    }
    return index;
  }

  ngAfterContentInit(): void {
    // Trigger change detection after content is initialized
    this.cdr.detectChanges();
  }
}
